import { useMemo, useState } from "react";
import Layout from "../../Shared/Layout";
import OrderFormAdmin from "./OrderFormAdmin";
import OrderTable from "./OrderTable/OrderTable";

const OrderPageAdmin = () =>{
    const [orders, setOrders] = useState([]); // Vos données orders
    const [statusFilter, setStatusFilter] = useState('all');

    // Filtrer les orders based on status
    const filteredOrders = useMemo(() => {
        if (statusFilter === 'all') return orders;
        return orders.filter(order => order.validationStatut === parseInt(statusFilter));
    }, [orders, statusFilter]);

    return(
         <>
            <Layout>
                <div className="content-body default-height">
                  <div className="container-fluid">
                      <div className="row">
                          <OrderFormAdmin/>
                          <div className="row mb-3">
                            <div className="col-md-3">
                            </div>
                          </div>
                          <OrderTable ordre={filteredOrders}/>
                      </div>
                  </div>
                </div>
            </Layout>
         </>
    );
};

export default OrderPageAdmin; 
  
   